module.exports = __webpack_public_path__ + "img/icon_savings.27d0a4fd.png";